import { render, staticRenderFns } from "./Pronunciamiento.vue?vue&type=template&id=be334c90"
import script from "./Pronunciamiento.vue?vue&type=script&lang=js"
export * from "./Pronunciamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports